/*eslint-disable */
export default function throttle(fn: (...args: any[]) => void, threshhold: number = 250, scope?: any) {
	let last: number;
	let deferTimer: any;
	return function(...subArgs: any[]) {
		let context = scope;

		let now: number = +new Date();
		// let	args = arguments;
		if (last && now < last + threshhold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function() {
				last = now;
				fn.apply(context, subArgs);
			}, threshhold);
		} else {
			last = now;
			fn.apply(context, subArgs);
		}
	};
}
